import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import useAuth from "./useAuth";
import { EntreprisesServices } from "$services";
import { CacheInvalidationAction } from "$utils/cache";

const { AddCompany, EditCompany, FetchSectors } = EntreprisesServices;

const useCompanyForm = (postSubmitAction?: any, hookTogglePopin?: any) => {
  const { token } = useAuth();
  const [submitting, setSubmitting] = useState(false);
  const [isOpened, setOpen] = useState<boolean>(false);
  const [isChildCompanyPopinOpened, setChildCompanyPopinOpened] =
    useState<boolean>(false);
  const [error, setError] = useState<string>("");

  const { data: sectors } = useQuery({
    queryKey: [CacheInvalidationAction.GET_SECTORS],
    queryFn: () => FetchSectors(token),
    gcTime: 5 * 60 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  const openPopin = () => {
    setOpen(true);
  };

  const openChildCompanyPopin = () => {
    setChildCompanyPopinOpened(true);
  };

  const togglePopin = (isOpen: boolean) => {
    if (!isOpen) {
      setError("");
    }
    setOpen(isOpen);
  };

  const toggleChildCompanyPopin = (isOpen: boolean) => {
    if (!isOpen) {
      setError("");
    }
    setChildCompanyPopinOpened(isOpen);
  };

  const handleSubmit = async (data: any) => {
    setSubmitting(true);
    const isEditingCompany = !!data._id;
    const createOrUpdateCompany = isEditingCompany ? EditCompany : AddCompany;

    try {
      // TODO: form still blink a little while updating
      await createOrUpdateCompany(token, { ...data }, data._id).then(
        async (body) => {
          if (body?.error) {
            setError(body.error || "Erreur lors de la création");
          } else {
            if (hookTogglePopin) {
              hookTogglePopin(false);
            } else {
              togglePopin(false);
              toggleChildCompanyPopin(false);
            }
            setError("");
            if (postSubmitAction) {
              postSubmitAction(body?._id, data);
            }
          }
        }
      );
    } catch (err) {
      setError(err.error || err.message || "Erreur Serveur");
    } finally {
      setSubmitting(false);
    }
  };

  const handleSiretData = async (siret: string) => {
    const result = await EntreprisesServices.GetSiretData(siret);
    return result;
  };

  return {
    sectors,
    error,
    handleSubmit,
    handleSiretData,
    isOpened,
    openPopin,
    isChildCompanyPopinOpened,
    openChildCompanyPopin,
    toggleChildCompanyPopin,
    submitting,
    togglePopin,
  };
};

export default useCompanyForm;
